
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Prop, Watch } from "vue-property-decorator";
    import { BriefingItemContainer } from "@/model/BriefingItemContainer";
    import Utils from "@/utilities/Utils";

    @Component({})
    export default class BriefingMatrixSection extends Vue {

        numberText: string = "";

        @Prop({ required: true }) item!: BriefingItemContainer;

        dragHandleImageUrl = require("@/images/drag-vert.svg");

        isEditing: boolean = false;
        oldValue: string = "";

        toggleSection() {
            if (!this.item?.section) return;
            this.item.section.isExpanded = !this.item.section.isExpanded;
        }

        edit() {
            this.oldValue = this.item?.section?.description ?? "";
            this.isEditing = true;
            Vue.nextTick(() => {
                //console.log("ref = ",  this.$refs.descriptionTextField);
                const element = ((this.$refs.descriptionTextField as any)?.$el) as Element;
                //console.log("element = ", element);
                const input = element?.querySelector("input:not([type=hidden])") as HTMLInputElement | null;
                //console.log("input = ", input);
                if (typeof input?.focus === "function") setTimeout(() => { input?.focus(); }, 10);
            });
            
        }

        saveEdit() {
            this.isEditing = false;
            if (!this.item?.section) return;
            if (Utils.isEmptyOrWhitespace(this.item.section.description)) {
                this.item.section.description = this.oldValue; // roll back if empty
            }
            else{
                this.$emit("changed", this.item);
            }
        }

        cancelEdit() {
            this.isEditing = false;
            if (!this.item?.section) return;
            this.item.section.description = this.oldValue;
        }

        remove() {
            this.$emit("remove", this.item);
        }

        get description(): string { return this.item?.section?.description ?? ""; }
        set description(value: string) {
            if(!this.item?.section) return;
            this.item.section.description = value;
        }

        get isExpanded(): boolean { return this.item?.section?.isExpanded ?? true; }

    }
